import { MessageSquare, Target, Library, Route } from 'lucide-react';
import { FEATURES } from './constants';

const ICONS = { MessageSquare, Target, Library, Route };

// "What you get" — glassmorphism feature grid. Colors reference brand tokens (--brand-*).
export default function NrouteFeatures() {
  return (
    <section id="features" className="relative py-20 md:py-28" style={{ backgroundColor: 'var(--brand-bg)' }}>
      <div className="mx-auto max-w-6xl px-4">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Built to find your path
          </h2>
          <p className="mt-4 text-lg text-slate-300">
            Not a list of links — a counsellor that reasons over a verified catalogue.
          </p>
        </div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {FEATURES.map((f) => {
            const Icon = ICONS[f.icon];
            return (
              <div
                key={f.title}
                className="group rounded-2xl border border-white/10 bg-white/[0.04] p-6 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-[#E8A838]/40 hover:shadow-[0_8px_40px_rgba(232,168,56,0.12)]"
              >
                <div
                  className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl"
                  style={{ backgroundColor: 'color-mix(in srgb, var(--brand-accent) 14%, transparent)' }}
                >
                  {Icon && <Icon size={22} style={{ color: 'var(--brand-accent)' }} />}
                </div>
                <h3 className="mb-2 text-lg font-semibold text-white">{f.title}</h3>
                <p className="text-sm leading-relaxed text-slate-400">{f.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
